import { render, staticRenderFns } from "./AmountModal.vue?vue&type=template&id=0fd7a018&scoped=true&"
import script from "./AmountModal.vue?vue&type=script&lang=js&"
export * from "./AmountModal.vue?vue&type=script&lang=js&"
import style0 from "./AmountModal.vue?vue&type=style&index=0&id=0fd7a018&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd7a018",
  null
  
)

export default component.exports